// Previous / "Page n of m" / Next for paged lists (changes, notifications). The ends are disabled, not dead clicks.

import { t } from "../i18n/i18n";
import { createButton, createElement } from "./dom";

/** The pager; goTo is called with the page to show. */
export function buildPager(page: number, pages: number, goTo: (page: number) => void): HTMLElement {
  const pager: HTMLDivElement = createElement("div", "toolbar");
  const previous: HTMLButtonElement = createButton("← " + t("app.previous"), (): void => {
    goTo(page - 1);
  });
  const next: HTMLButtonElement = createButton(t("app.next") + " →", (): void => {
    goTo(page + 1);
  });
  previous.disabled = page <= 1;
  next.disabled = page >= pages;
  pager.append(previous, createElement("span", "", t("changes.page", { page, pages })), next);
  return pager;
}
